import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import TagFilter from 'components/molecules/TagFilter';
import {
	actionCreators as transientPoolStateAC,
	getActiveOverlayRef,
	getFilters,
	getProgramItemRef,
} from 'store/transientPoolState';
import { RootStateType as TransientPoolStateType } from 'store/transientPoolState';
import { PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';

type RootStateType = TransientPoolStateType;

type OwnPropsType = {
	selectedPool: PoolEnumType;
};

type StateProps = {
	programItemRef?: string;
	activeOverlayRef?: string;
	filters?: {
		[filterKey: string]: string;
	};
};

const mapStateToProps = (state: any, ownProps: any): any => {
	return {
		programItemRef: getProgramItemRef(state),
		activeOverlayRef: getActiveOverlayRef(state),
		filters: ownProps.selectedPool ? getFilters(state, ownProps.selectedPool) : {},
	} as any;
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
	return bindActionCreators(
		{
			doAddPersistentFilter: transientPoolStateAC.doAddPersistentFilter,
			doRemovePersistentFilter: transientPoolStateAC.doRemovePersistentFilter,
			doSetPersistentFilter: transientPoolStateAC.doSetPersistentFilter,
			doUnsetPersistentFilter: transientPoolStateAC.doUnsetPersistentFilter,
			doUnsetAllFilters: transientPoolStateAC.doUnsetAllFilters,
			doSetProgramItemRef: transientPoolStateAC.doSetProgramItemRef,
			doUnsetProgramItemRef: transientPoolStateAC.doUnsetProgramItemRef,
			doSetOverlayRef: transientPoolStateAC.doSetOverlayRef,
			doUnsetOverlayRef: transientPoolStateAC.doUnsetOverlayRef,
			doUnsetCurrentOverlayRef: transientPoolStateAC.doUnsetCurrentOverlayRef,
		},
		dispatch
	);
};

export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(TagFilter as any) as any;
